

import React, { memo, useEffect, useState, useCallback } from 'react';
import { withSize } from 'react-sizeme';
import cx from 'classnames';
import { Text, Checkbox, Icon, Link } from '../../../../../../ui-kit';
import EditCost from '../../common/EditCost';
import { extractCostParts, getAddonTotalCost, getCostRange } from '../../../../utils';
import { handleCostChange } from '../../utils';
import { SMALL_SIZE, VIDEO_REVIEW } from '../../constants';

import { ABOUT_ADDON_OPTIONS } from '../../../../../../common/constants';
import ConfirmationModalForRushEdit from '../../../ConfirmationModalForRushEdit/ConfirmationModalForRushEdit';
import AboutAddonModal from '../../../../AboutAddonModal';

import '../../styles/_expandable-addon.scss';






















const DEFAULT_COST = '0';

function toggleAddonEnabled({
  cost,
  selected,
  setSelected,
  onChangeAddon,
  setAddonTotalCost,
  setSelectedValue,
  onChangeSelectedCaption








}) {
  return () => {
    const newSelected = !selected;
    setSelected(newSelected);
    onChangeSelectedCaption(newSelected);

    if (newSelected) {
      const createdAt = new Date().toISOString();
      const newValue = { value: true, cost, createdAt };

      setAddonTotalCost(getAddonTotalCost({ selectedValue: { cost } }));
      setSelectedValue(newValue);
      return void onChangeAddon(newValue);
    }

    setAddonTotalCost(0);
    setSelectedValue(null);
    onChangeAddon(null);
  };
}

function BooleanValueAddon({
  name,
  title,
  subtitle,
  options,
  viewMode,
  addonValue,
  costPreffix,
  icon,
  size: { width },
  onChangeAddon,
  onInfoClick,
  getAddonsCostByType,
  getBillingEntityCode,
  onCheckboxStateChange,
  disabled,
  withInfo = false,
  editingMode = false,
  showAboutInfo = false
}) {
  const [selectedValue, setSelectedValue] = useState(addonValue);
  const [selected, setSelected] = useState(Boolean(addonValue));
  const [addonTotalCost, setAddonTotalCost] = useState(getAddonTotalCost({ selectedValue }));
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [
  showConfirmationModalForRushEdit,
  setShowConfirmationModalForRushEdit] =
  useState(Boolean(false));

  const onToggleConfirmationModalForRushEdit = () => {
    const value = !showConfirmationModalForRushEdit;
    setShowConfirmationModalForRushEdit(value);
  };

  const onToggleAboutModal = useCallback(
    () => setShowAboutModal(!showAboutModal),
    [showAboutModal]
  );

  const optionWithCost = options.find(({ value }) => value);
  const cost = optionWithCost ? optionWithCost.cost : DEFAULT_COST;
  const { maxCost, currencySymbol } = getCostRange(options);

  const isMobile = width <= SMALL_SIZE;
  const isVideoReview = viewMode === VIDEO_REVIEW;

  // TODO: Get rid of this part of code when will be no more projects with SUPER_RUSH_EDIT addon
  // TODO: Fix other backward compatibility code related to SUPER_RUSH_EDIT addon
  const [superRushEditCostStr, setSuperRushEditCostStr] = useState('');
  /* istanbul ignore next */
  useEffect(() => {
    if (addonValue && addonValue.value === 'SUPER_RUSH_EDIT') {
      if (disabled) {
        const superRushEditCost = getAddonsCostByType({
          addonType: addonValue.value,
          numberValue: false
        });
        const parts = extractCostParts(superRushEditCost);
        setSuperRushEditCostStr(`${parts.currencySymbol}${parts.cost}`);
      } else {
        onChangeAddon(null);
        setSelected(false);
      }
    }
  }, []);

  const onChangeSelectedCaption = (checkboxSelected) => {
    if (onCheckboxStateChange) {
      onCheckboxStateChange(checkboxSelected);
    }
  };

  const showAboutInformation = showAboutInfo && ABOUT_ADDON_OPTIONS[name];

  const onChangeCheckbox = () => {
    if (title === 'Rush Edit') {
      onToggleConfirmationModalForRushEdit();
    } else {
      toggleAddonEnabled({
        selectedValue,
        setSelected,
        selected,
        onChangeAddon,
        cost,
        setAddonTotalCost,
        setSelectedValue,
        onChangeSelectedCaption
      })();
    }
  };

  return (
    <div className={cx('expandable-addon', { 'expandable-addon--small': isMobile })}>
      <div className="expandable-addon__wrapper">
        <div className="expandable-addon__main">
          <div>
            {
            !isVideoReview &&
            <div className="expandable-addon__col">
                  <Checkbox
                checked={selected}
                onChange={() => onChangeCheckbox()}
                disabled={disabled}
                className="expandable-addon__checkbox">

                    <Icon className="expandable-addon__icon" name={icon} size={22} />

                    <Text heading5 className="expandable-addon__title">{title}</Text>
                  </Checkbox>
                  {/* eslint-disable-next-line max-len */}
                  {/* TODO: This part should be replaced only by second expression of the ternary operator when will be no more projects with SUPER_RUSH_EDIT addon */}
                  {/* eslint-disable-next-line max-len */}
                  {/* TODO: Fix other backward compatibility code related to SUPER_RUSH_EDIT addon */}
                  {!editingMode &&
              <div>
                      {
                disabled && addonValue && addonValue.value === 'SUPER_RUSH_EDIT' ?
                <Text heading5 className="expandable-addon__cost">{superRushEditCostStr}</Text> :
                <Text heading5 className="expandable-addon__cost">{`${costPreffix || ''} ${currencySymbol}${maxCost}`}</Text>}

                    </div>}

                </div>}



            {
            withInfo &&
            <div className="expandable-addon__col">
                  <Icon className="expandable-addon__info" name="info" size={16} onClick={onInfoClick} />
                </div>}



            {
            showAboutInformation &&
            <div className="expandable-addon__col expandable-addon__col_content-right">
                  <Link className="expandable-addon__about" onClick={onToggleAboutModal}>
                    {ABOUT_ADDON_OPTIONS[name].LINK_TEXT}
                  </Link>
                </div>}


          </div>

          {!isVideoReview && <Text className="expandable-addon__subtitle">{subtitle}</Text>}
        </div>

        {editingMode && selected &&
        <div>
            <EditCost
            onChangeCost={(costValue) => handleCostChange({
              costValue,
              selectedValue,
              setSelectedValue,
              onChangeAddon,
              setAddonTotalCost
            })}
            addonName={name}
            cost={addonTotalCost}
            getBillingEntityCode={getBillingEntityCode}
            disabled={disabled} />

          </div>}

      </div>
      {
      showConfirmationModalForRushEdit &&
      <ConfirmationModalForRushEdit
        onClick={
        toggleAddonEnabled({
          selectedValue,
          setSelected,
          selected,
          onChangeAddon,
          cost,
          setAddonTotalCost,
          setSelectedValue,
          onChangeSelectedCaption
        })}

        visible={showConfirmationModalForRushEdit}
        onClose={onToggleConfirmationModalForRushEdit} />}



      {
      showAboutInformation &&
      <AboutAddonModal
        addonType={name}
        visible={showAboutModal}
        onClose={onToggleAboutModal} />}



    </div>);

}

export default memo(withSize()(BooleanValueAddon));